export default __webpack_public_path__ + "static/media/upload-icon.0eb6c67b.svg";